import { Button, Link, Modal, Paper, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "store/StoreConfigs";
import { ReactComponent as AssignEventMenuCloseBtn } from "icons/AssignEventMenuCloseBtn.svg";
import { ReactComponent as AddDocumentPlus } from "icons/AddDocumentPlus.svg";
import { attachedFilesModalStyles } from "./AttachedFilesModalStyles";
import { EventAttachment } from "models/thorEventModels/EventAttachment";
import { services } from "api/serviceConfig";
import { ReactComponent as DisabledPlus } from "icons/DisabledPlus.svg";
import clsx from "clsx";
import { EventStatus } from "models/thorEventModels/EventDetails";

export default observer(function AttachedFilesModal() {
    const { thorEventViewStore, identityStore } = useStore();
    const classes = attachedFilesModalStyles();

    const isUserHavePermission: boolean =
        identityStore.userInfo?.email ===
        (thorEventViewStore.eventDetails.reviewerUserId || thorEventViewStore.eventDetails.qaUserId);

    const onRemoveFile = async (file: EventAttachment) => {
        await services.Thor.deleteEventAttachment(file.id, identityStore.currentCustomerId);
        const indexOf = thorEventViewStore.attachedFiles.findIndex((f) => f.id === file.id);
        thorEventViewStore.attachedFiles.splice(indexOf, 1);
    };

    const downloadFile = async (file: EventAttachment) => {
        const resp = await services.Thor.getDownloadPresignedUrl(file.id, identityStore.currentCustomerId);
        const blobResponse = await services.Thor.downloadFromS3WithPresignedUrl(resp.data.url);
        if (blobResponse.status !== 200) {
            return;
        }
        const link = window.URL.createObjectURL(blobResponse.data);
        const stylesheet = document.createElement("a");
        stylesheet.href = link;
        stylesheet.download = resp.data.eventAttachment.fileName;
        stylesheet.click();
    };

    return (
        <Modal
            onClose={() => {
                thorEventViewStore.setFileViewModalOpen(false);
            }}
            open={thorEventViewStore.isFileViewModalOpen}
            className={classes.modal}
        >
            <Paper className={classes.main}>
                <AssignEventMenuCloseBtn
                    className={classes.closeIcon}
                    onClick={() => {
                        thorEventViewStore.setFileViewModalOpen(false);
                    }}
                />
                <Typography variant="h3">Attached Documents</Typography>
                <Typography>View all of the attached documents for this event</Typography>

                <div className={classes.resultDocumentsList}>
                    {thorEventViewStore.attachedFiles && (
                        <Typography>
                            {thorEventViewStore.attachedFiles.map((x, index) => (
                                <Typography key={x.fileName + index}>
                                    <Link
                                        href="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            downloadFile(x);
                                        }}
                                    >
                                        {x.fileName}
                                    </Link>
                                    {isUserHavePermission &&
                                        thorEventViewStore.eventDetails.eventStatusId !== EventStatus.Closed && (
                                            <Button
                                                onClick={() => {
                                                    onRemoveFile(x);
                                                }}
                                            >
                                                x
                                            </Button>
                                        )}
                                </Typography>
                            ))}
                        </Typography>
                    )}
                </div>

                <Typography
                    onClick={() => {
                        if (
                            isUserHavePermission &&
                            thorEventViewStore.eventDetails.eventStatusId !== EventStatus.Closed
                        ) {
                            thorEventViewStore.setFileAttachModalOpen(true);
                        }
                    }}
                    className={clsx({
                        [classes.fileIconSpace]: isUserHavePermission,
                        [classes.disabledField]:
                            !isUserHavePermission ||
                            thorEventViewStore.eventDetails.eventStatusId === EventStatus.Closed,
                    })}
                >
                    {isUserHavePermission && thorEventViewStore.eventDetails.eventStatusId !== EventStatus.Closed ? (
                        <AddDocumentPlus className={classes.fileIcon} />
                    ) : (
                        <DisabledPlus className={classes.fileIcon} />
                    )}{" "}
                    Add New Document
                </Typography>
            </Paper>
        </Modal>
    );
});
